import { render, staticRenderFns } from "./KindergardensExplorer.vue?vue&type=template&id=68b8b19c&scoped=true&"
import script from "./KindergardensExplorer.vue?vue&type=script&lang=js&"
export * from "./KindergardensExplorer.vue?vue&type=script&lang=js&"
import style0 from "./KindergardensExplorer.vue?vue&type=style&index=0&id=68b8b19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8b19c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
